module.exports = __webpack_public_path__ + "img/e947bdb.png";